import { createContext } from 'react';

const MyContext = createContext();

export { MyContext }
